import React from 'react';
import PropTypes from "prop-types";
import NumberFormat from "react-number-format";

function Float(props) {
    const inputRef = React.createRef()
    props.elementProps.onKeyPress = function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            return e.target.blur()
        }
        const charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
        const charStr = String.fromCharCode(charCode);
        const digit = (/\d/.test(charStr) || charStr === '.')
        if (!digit) e.preventDefault();
    }
    props.elementProps.onBlur = function (e) {
        const val = (e.target.value === '') ? 0 : parseFloat(e.target.value)
        props.setAnswer(val)
    }
    const validity = props.elementProps.isValid ? 'is-valid' : props.elementProps.isInvalid ? 'is-invalid' : ''
    const wizardStyle = props?.expandedStyle === 'wizard' ? 'transitionable delay-2' : ''
    const handleBlur = function (e) {
        let val = e.target.value
        val = val === '' ? 0 : parseFloat(val)
        props.setAnswer(val)
    }
    return <NumberFormat
        defaultValue={props.elementProps.defaultValue}
        displayType="tel"
        //thousandSeparator={true}
        prefix={props?.prefix}
        suffix={props?.suffix}
        decimalScale={2}
        allowNegative={false}
        className={`form-control int ${wizardStyle} ${props?.expandedStyle || ''} ${validity}`}
        onBlur={handleBlur}
        getInputRef={inputRef}
        onKeyPress={(e)=>{if (e.key === 'Enter' || e.keyCode === 13) {e.target.blur()}}}
    />
   // return (<TextField type="tel" {...props.elementProps} />)
}
Float.propTypes = {
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setAnswer: PropTypes.func,
    onFocus: PropTypes.func,
    rightElement: PropTypes.element,
    clean: PropTypes.func
};
export default Float;